import { render, staticRenderFns } from "./FlmView.vue?vue&type=template&id=2bec389b"
import script from "./flmView.ts?vue&type=script&lang=js&external"
export * from "./flmView.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports